// extracted by mini-css-extract-plugin
module.exports = {"markdownContent":"markdown_markdownContent__XLyla"};